// extracted by mini-css-extract-plugin
export default {"AuthAnimation":"AuthAnimation_AuthAnimation__LMR5G","fadein":"AuthAnimation_fadein__kvBne"};